import React, { useState } from "react";
import PageTransition from "../components/PageTransition";
import snowRemovalEquipment from "../assets/images/banner/snow-removal-equipment.jpg";

const API_ENDPOINT = `${process.env.REACT_APP_API_BASE_URL}/send-snow-removal-inquiry`;

const SnowRemoval = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    address: "",
    service: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [submitStatus, setSubmitStatus] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitStatus("");
    setIsSubmitting(true);
    try {
      const response = await fetch(API_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
        mode: "cors",
      });
      const responseText = await response.text();
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (parseError) {
        data = { message: responseText };
      }
      if (!response.ok) {
        throw new Error(data.message || "Failed to send inquiry");
      }
      setSubmitStatus("success");
      e.target.reset();
      setFormData({ name: "", phone: "", address: "", service: "" });
    } catch (error) {
      setError(error.message || "Failed to send inquiry. Please try again.");
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <PageTransition>
      <div className="container mx-auto px-6 md:px-4 py-16 max-w-3xl">
        {/* Banner Image */}
        <div className="mb-8 text-center">
          <img
            src={snowRemovalEquipment}
            alt="Larry's Snow Removal Equipment"
            className="w-full h-64 md:h-80 object-cover rounded-lg shadow-lg"
          />
        </div>

        {/* Title Section */}
        <div className="text-center mb-10">
          <h1 className="text-[2.2rem] font-bold text-blue-900 mb-2">
            Larry's Snow Removal
          </h1>
          <h2 className="text-lg md:text-xl text-blue-800 mb-6 font-medium">
            Blue Lake Springs and Surrounding Subdivisions
          </h2>
          <p className="text-gray-700 mb-8">
            Snow removal services now available for the 2025-2026 season.
          </p>
        </div>

        {/* Who We Serve and Why Us Section */}
        <div className="mb-10">
          <div className="grid md:grid-cols-2 gap-8 items-start">
            {/* Who We Serve */}
            <div>
              <h3 className="text-xl font-semibold text-blue-900 mb-4 text-center">
                Who We Serve:
              </h3>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Full-time homeowners</li>
                <li>Part-time residents</li>
                <li>
                  Airbnb & vacation rental properties            
                  <br />
                  <span className="text-gray-600 text-sm">
                    (reliable access for your guests checking-in and checking-out)
                  </span>
                  
                </li>
              </ul>
            </div>

            {/* Why Us */}
            <div>
              <h3 className="text-xl font-semibold text-blue-900 mb-4 text-center">
                Why Us?
              </h3>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Personalized service for every property</li>
                <li>Reliable, new equipment</li>
                <li>Fully insured</li>
                <li>References available</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Additional Info Section */}
        <div className="text-center mb-10">
          {/* <p className="text-gray-700 mb-4">
            Specializing in the Blue Lakes Springs area and surrounding
            Subdivisions.
          </p>
          <p className="text-gray-700 mb-4">
            We cater to the individual needs of full time and part time homes
            and the check in-check out needs of Airbnb's struggling to provide
            reliable access to renters.
          </p>
          <p className="text-gray-700 mb-6">
            We run new equipment for reliability and are fully insured.
            References available.
          </p> */}
          <p className="text-gray-700 mb-4">
          Message us today for an estimate and secure your spot before the snow hits.
          </p>
        
        </div>

        {/* Contact Section */}
        <div className="text-center mb-12">
          <p className="text-blue-700 font-semibold text-lg">
            Please text{" "}
            <a href="tel:2098401175" className="underline hover:text-blue-900">
              209-840-1175
            </a>{" "}
            for an estimate.
          </p>
        </div>

        {/* Form Section */}
        {error && (
          <div className="bg-red-50 text-red-600 p-4 rounded-lg mb-6">
            {error}
          </div>
        )}
        {submitStatus === "success" && (
          <div className="bg-green-50 text-green-600 p-4 rounded-lg mb-6">
            Inquiry sent successfully! We'll get back to you soon.
          </div>
        )}
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-black mb-2">Name *</label>
            <input
              type="text"
              name="name"
              required
              value={formData.name}
              onChange={handleInputChange}
              disabled={isSubmitting}
              className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:border-blue-700 disabled:bg-gray-100"
            />
          </div>
          <div>
            <label className="block text-black mb-2">Phone *</label>
            <input
              type="tel"
              name="phone"
              required
              value={formData.phone}
              onChange={handleInputChange}
              disabled={isSubmitting}
              className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:border-blue-700 disabled:bg-gray-100"
            />
          </div>
          <div>
            <label className="block text-black mb-2">Zip Code</label>
            <input
              type="text"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
              disabled={isSubmitting}
              className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:border-blue-700 disabled:bg-gray-100"
            />
          </div>
          <div>
            <label className="block text-black mb-2">
              Service Needed & Additional Information *
            </label>
            <textarea
              name="service"
              required
              value={formData.service}
              onChange={handleInputChange}
              disabled={isSubmitting}
              rows="5"
              className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:border-blue-700 disabled:bg-gray-100"
            ></textarea>
          </div>
          <div className="flex justify-center w-full mt-6">
            <button
              type="submit"
              disabled={isSubmitting}
              className="bg-[#04549D] text-white px-8 py-2 rounded hover:bg-blue-900 disabled:bg-gray-400 font-semibold"
            >
              {isSubmitting ? "Sending..." : "Send Inquiry"}
            </button>
          </div>
        </form>
      </div>
    </PageTransition>
  );
};

export default SnowRemoval;
